import { isDev, isPreview, isProd } from "@/utils/environments";
import { StatsigEnvironment } from "./types";

export const getStatsigEnvironment = (): StatsigEnvironment => {
  if (isDev()) {
    return "development";
  }
  if (isPreview()) {
    return "staging";
  }
  if (isProd()) {
    return "production";
  }

  return "development";
};
